import { styled } from "@mui/system";

export const StyledPage = styled('div')(({theme}) => ({
    display: 'flex',
    height: '101vh',
    width: '100%',
    color: '#fff'
}))